import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "project-slider",
  "data-scroll": ""
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  class: "main",
  "data-component-name": "slider"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "top-layer" }, null, -1)
const _hoisted_5 = { class: "swiper-cont" }
const _hoisted_6 = { class: "item luxury uppercase wc-lg noselect" }
const _hoisted_7 = { class: "slide-cont" }
const _hoisted_8 = { class: "innerShape" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  width: "100%",
  viewBox: "0 0 1120 153",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "mainPath",
    opacity: "0.2",
    d: "M1119 76.5C1119 81.2548 1115.46 86.1501 1108.07 91.0857C1100.72 95.9907 1089.82 100.761 1075.69 105.326C1047.43 114.451 1006.49 122.684 955.844 129.603C854.562 143.439 714.609 152 560 152C405.391 152 265.438 143.439 164.156 129.603C113.507 122.684 72.5694 114.451 44.3149 105.326C30.1807 100.761 19.2798 95.9907 11.9324 91.0857C4.53918 86.1501 1 81.2548 1 76.5C1 71.7452 4.53918 66.8499 11.9324 61.9143C19.2798 57.0093 30.1807 52.2393 44.3149 47.6743C72.5694 38.5488 113.507 30.3161 164.156 23.3971C265.438 9.56118 405.391 1 560 1C714.609 1 854.562 9.56118 955.844 23.3971C1006.49 30.3161 1047.43 38.5488 1075.69 47.6743C1089.82 52.2393 1100.72 57.0093 1108.07 61.9143C1115.46 66.8499 1119 71.7452 1119 76.5Z",
    stroke: "#182236",
    "stroke-width": "2"
  })
], -1)
const _hoisted_10 = ["id", "onClick", "onMousedown", "onMouseup"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "mask" }, null, -1)
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "desc fira uppercase disable-drag wc-lg noselect" }
const _hoisted_14 = { class: "ttl fira bold uppercase disable-drag wc-lg noselect" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1)
const _hoisted_16 = { class: "uppercase fira bold noselect" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "outsideShape" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "100%",
    height: "218",
    viewBox: "0 0 1594 218",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      opacity: "0.05",
      d: "M1592.35 109C1592.35 115.974 1587.16 123.036 1576.62 130.064C1566.12 137.062 1550.58 143.85 1530.47 150.338C1490.25 163.31 1432.01 175.006 1359.97 184.833C1215.92 204.486 1016.87 216.646 796.997 216.646C577.12 216.646 378.078 204.486 234.023 184.833C161.988 175.006 103.744 163.31 63.5293 150.338C43.4149 143.85 27.8704 137.062 17.3745 130.064C6.83242 123.036 1.64062 115.974 1.64062 109C1.64062 102.027 6.83242 94.9652 17.3745 87.9368C27.8704 80.9391 43.4149 74.1506 63.5293 67.6627C103.744 54.6913 161.988 42.9952 234.023 33.1677C378.078 13.5146 577.12 1.35547 796.997 1.35547C1016.87 1.35547 1215.92 13.5146 1359.97 33.1677C1432.01 42.9952 1490.25 54.6913 1530.47 67.6627C1550.58 74.1506 1566.12 80.9391 1576.62 87.9368C1587.16 94.9652 1592.35 102.027 1592.35 109Z",
      stroke: "#182236",
      "stroke-width": "2"
    })
  ])
], -1)
const _hoisted_18 = { class: "stage" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "dot-pulse" }, null, -1)
const _hoisted_20 = [
  _hoisted_19
]

import gsap from "gsap";
import MotionPathPlugin from "gsap/MotionPathPlugin";
import {computed} from "@vue/reactivity";
import {get} from "lodash";
import {Swiper, SwiperSlide} from "swiper/vue/swiper-vue";
import {ref, onMounted, watch, Ref, nextTick} from "vue";
import {useMenuStore} from "@/store/pinia/menu";
import {isInViewport} from "@/composables/mobileWatcher";
import {handleResize} from "@/composables/resizeHandler";
//@ts-ignore
import imagesLoaded from "imagesloaded";

interface getDataArr {
    customID: number;
    imageIndex: number;
    frames: [];
    incressStep_Image: number;
    maxFrameStep: number;
}

interface swiperOptions {
    slidesPerView: number | "auto";
    spaceBetween: number;
    loop: boolean;
    centeredSlides: boolean;
    speed: number;
}

// Define store

export default /*#__PURE__*/_defineComponent({
  props: {
    contentData: {
        type: Object,
    },
},
  setup(__props) {

const props = __props

/**
 * @author Tornike Jortmenadze (Jortsoft)
 */

const {windowWidth} = handleResize();

// Define interfaces
const store = useMenuStore();

// Define props


// Register plugins
gsap.registerPlugin(MotionPathPlugin);

// Define global variables
const circulationPoints = {
    left: 0.5,
    top: 0.75,
    right: 1,
    bottom: 0.25,
};
const countImagePoints: Array<number> = [25, 50, 75, 0];
const swiperOptions: swiperOptions = {
    slidesPerView: "auto",
    spaceBetween: 0,
    loop: true,
    centeredSlides: true,
    speed: 1000,
};
const locoScrollY = computed(() => store.locoScrollY);
const imageFormat = "webp";
let downX: number = 0;
let upX: number = 0;
const renderSwiper: Ref<boolean> = ref(false);
const stepImage: number = 25;
const maxImageFrameCount: number = 100;
const intervalSpeed: number = 40; //40
let interval: number;
const movementDuration: number = 1;
const incressStep: number = 0.25;
const clickActive: Ref<boolean> = ref(true);
const timeBreak: any = ref(null);
const swiper = ref(null);
// const domainData: string = `https:/${window.location.hostname}/static/projects/`; // Dynamic link
const domainData: string = `https://alliance.ge/static/projects/`; // Static link
// const preload = ref(false);
const imageContainer = ref([]);

// Define watcher
watch(locoScrollY, () => {
    moveSwiperScroll();
});

// Define reactive data
const getData = computed(() => {
    let arr = get(props, "contentData.data.list");
    arr[0].startPlace = circulationPoints.left;
    arr[1].startPlace = circulationPoints.top;
    arr[2].startPlace = circulationPoints.right;
    arr[3].startPlace = circulationPoints.bottom;
    arr.forEach((item: getDataArr, index: number) => {
        item.customID = index + 1;
        item.imageIndex = 0;
        item.frames = [];
        item.incressStep_Image = 0;
        item.maxFrameStep = 0;
    });
    arr.forEach(
        (
            item: {
                domainData: string;
                frames: Array<string>;
                projectDirectoryMobile: string;
                projectDirectory: string;
            },
            index: number
        ) => {
            for (let i = 0; i < maxImageFrameCount; i++) {
                if (window.innerWidth < 1024) {
                    item.frames.push(
                        `${domainData}${item?.projectDirectoryMobile}/${i}.${imageFormat}`
                    );
                } else {
                    item.frames.push(
                        `${domainData}${item?.projectDirectory}/${i}.${imageFormat}`
                    );
                }
            }
        }
    );
    return arr;
});

let customIndex = ref(getData.value.length);

function moveSwiperScroll(): void {
    // if (
    //     !isInViewport(
    //         document.querySelector(".project-slider .main .slide-cont .item")
    //     )
    // )
    //     return;
    if (windowWidth.value < 1024) {
        // swiper.value.update();
        document.getElementById("app").addEventListener("scroll", (e: any) => {
            gsap.to(".project-slider .swiper-cont", {
                x: document.getElementById("app").scrollTop / 15,
            });
        });
    } else {
        swiper.value.update();
        gsap.to(".project-slider .swiper-cont", {
            x: locoScrollY.value === 0 ? 0 : locoScrollY.value / 8,
        });
    }
}

function circulationAnim(
    arr: { customID: number; startPlace: number }[],
    incress: boolean
): void {
    arr.forEach((item) => {
        gsap.to(`.project-slider .item._${item.customID}`, {
            duration: movementDuration,
            ease: "Power1.easeInOut",
            force3D: false,
            motionPath: {
                path: "#mainPath",
                align: "#mainPath",
                autoRotate: false,
                alignOrigin: [0.5, 0.5],
                start: item.startPlace,
                end:
                    incress === true
                        ? item.startPlace + incressStep
                        : item.startPlace - incressStep,
            },
        });
        if (incress) {
            item.startPlace = item.startPlace + incressStep;
        } else {
            item.startPlace = item.startPlace - incressStep;
        }
    });
}

function moveBackgroundSwiper(move: boolean) {
    if (!move) {
        swiper.value.slideNext();
    } else {
        swiper.value.slidePrev();
    }
}

function nextSlide(): void {
    if (!clickActive.value) {
        return;
    }
    clearTimeout(timeBreak.value);
    if (customIndex.value === 1) {
        customIndex.value = getData.value.length + 1;
    }
    customIndex.value--;
    getData.value.forEach((item: { maxFrameStep: number }) => {
        item.maxFrameStep += stepImage;
    });
    circulationAnim(getData.value, true);
    checkHideFun(getData.value);
    clickActive.value = false;
    interval = window.setInterval(() => {
        imageAnimation(true);
    }, intervalSpeed);
    timeBreak.value = window.setTimeout(() => {
        clickActive.value = true;
    }, 1300);
    moveBackgroundSwiper(true);
}

function prevSlide(): void {
    if (!clickActive.value) {
        return;
    }
    clearTimeout(timeBreak.value);
    if (customIndex.value >= 4) {
        customIndex.value = 0;
    }
    customIndex.value++;
    getData.value.forEach(
        (item: { maxFrameStep: number; incressStep_Image: number }) => {
            if (item.maxFrameStep <= 0) {
                item.maxFrameStep = maxImageFrameCount - stepImage;
                item.incressStep_Image = maxImageFrameCount - 1;
            } else {
                item.maxFrameStep -= stepImage;
            }
        }
    );
    circulationAnim(getData.value, false);
    checkHideFun(getData.value);
    clickActive.value = false;
    interval = window.setInterval(() => {
        imageAnimation(false);
    }, intervalSpeed);
    timeBreak.value = window.setTimeout(() => {
        clickActive.value = true;
    }, 1300);
    moveBackgroundSwiper(false);
}

function checkHideFun(
    arr: Array<{ customID: number; startPlace: number }>
): void {
    // Show all
    arr.forEach((item) => {
        gsap.to(`.project-slider .item._${item.customID}`, {
            duration: movementDuration - 0.3,
            ease: "Power1.easeInOut",
            opacity: 1,
            scale: 1,
        });
    });
    // Hide bottom element
    arr.forEach((item) => {
        if (item.startPlace === -incressStep) {
            item.startPlace = 0.75;
        }
        if (item.startPlace % 1 === circulationPoints.top) {
            gsap.to(`.project-slider .item._${item.customID}`, {
                duration: movementDuration - 0.3,
                ease: "Power1.easeInOut",
                opacity: 0,
                scale: 0.5,
            });
        }
    });
}

function switchSlider(item: { customID: number; startPlace: number }): void {
    if (
        document.querySelector(`.project-slider .item._${item.customID}`) !==
        null
    ) {
        if (
            !document
                .querySelector(`.project-slider .item._${item.customID}`)
                .classList.contains("active")
        ) {
            if (item.startPlace < 0) {
                item.startPlace = circulationPoints.left;
            }
            if (item.startPlace % 1 === circulationPoints.left) {
                prevSlide();
            } else {
                nextSlide();
            }
        } else {
        }
    }
}

function uploadImages(): void {
    getData.value.forEach((item: any, index: number) => {
        item.incressStep_Image = countImagePoints[index];
        item.maxFrameStep = countImagePoints[index];
        const canvas: any = document.querySelector(
            `.project-slider .item._${item.customID} canvas`
        );
        if (canvas !== null || canvas !== undefined) {
            canvas.width = 700;
            canvas.height = 700;
            // const context = canvas.getContext("2d");
            // context.imageSmoothingEnabled = true;
            // context.imageSmoothingQuality = "high";
            // let base_image = new Image();

            // base_image.src = item.frames[item.incressStep_Image];
            canvas.style.backgroundImage = `url(${item.frames[item.incressStep_Image]
            })`;
            // base_image.onload = function () {
            //     context.clearRect(0, 0, canvas.width, canvas.height);
            //     context.drawImage(
            //         base_image,
            //         0,
            //         0,
            //         canvas.width,
            //         canvas.height
            //     );
            // };
        }
    });
    getData.value.forEach((item: any) => {
        item.frames.forEach((img: any) => {
            imageContainer.value.push(img);
        });
    });
}

function initCanvas(item: {
    customID: number;
    frames: [];
    incressStep_Image: number;
}) {
    const canvas: any = document.querySelector(
        `.project-slider .item._${item.customID} canvas`
    );
    if (canvas !== null || canvas !== undefined) {
        canvas.width = 700;
        canvas.height = 700;
        // const context = canvas.getContext("2d");
        // context.imageSmoothingEnabled = true;
        // context.imageSmoothingQuality = "high";
        // let base_image = new Image();
        // base_image.src = item.frames[item.incressStep_Image];
        canvas.style.backgroundImage = `url(${item.frames[item.incressStep_Image]
        })`;
        // context.clearRect(0, 0, canvas.width, canvas.height);
        // context.drawImage(base_image, 0, 0, canvas.width, canvas.height);
    }
}

function frameIncressSteps(): void {
    getData.value.forEach((item: any) => {
        initCanvas(item);
    });
}

function imageAnimation(incress: boolean): void {
    if (incress) {
        // next Slide event
        getData.value.forEach(
            (item: { incressStep_Image: number; maxFrameStep: number }) => {
                if (item.incressStep_Image >= item.maxFrameStep - 1) {
                    return repeatImageCounter(incress);
                }
                item.incressStep_Image++;
            }
        );
    } else {
        // Prev slide event
        getData.value.forEach(
            (item: { incressStep_Image: number; maxFrameStep: number }) => {
                if (item.incressStep_Image === item.maxFrameStep) {
                    return repeatImageCounter(incress);
                }
                item.incressStep_Image--;
            }
        );
    }
    frameIncressSteps();
}

function repeatImageCounter(incress: boolean): void {
    if (incress) {
        // Next slide end
        getData.value.forEach(
            (item: { maxFrameStep: number; incressStep_Image: number }) => {
                if (item.maxFrameStep >= maxImageFrameCount) {
                    item.incressStep_Image = 0;
                    item.maxFrameStep = 0;
                }
            }
        );
    } else {
    }
    clearInterval(interval);
}

function slideTouchEventsMobile(): void {
    const elem = document.querySelector(".project-slider .main");
    elem.addEventListener("touchstart", handleTouchStart, false);
    elem.addEventListener("touchmove", handleTouchMove, false);

    var xDown: number = null;
    var yDown: number = null;

    function getTouches(evt: any) {
        return (
            evt.touches || // browser API
            evt.originalEvent.touches
        ); // jQuery
    }

    function handleTouchStart(evt: any) {
        const firstTouch = getTouches(evt)[0];
        xDown = firstTouch.clientX;
        yDown = firstTouch.clientY;
    }

    function handleTouchMove(evt: any) {
        if (!xDown || !yDown) {
            return;
        }

        var xUp = evt.touches[0].clientX;
        var yUp = evt.touches[0].clientY;

        var xDiff = xDown - xUp;
        var yDiff = yDown - yUp;

        if (Math.abs(xDiff) > Math.abs(yDiff)) {
            /*most significant*/
            if (xDiff > 0) {
                /* left swipe */
                nextSlide();
            } else {
                /* right swipe */
                prevSlide();
            }
        }
        /* reset values */
        xDown = null;
        yDown = null;
    }
}

function onSwiper(e: any): void {
    swiper.value = e;
}

function mouseDown(item: { customID: number }, e: any): void {
    if (window.innerWidth < 1024) {
        return;
    }
    if (
        document.querySelector(`.project-slider .item._${item.customID}`) !==
        null
    ) {
        if (
            document
                .querySelector(`.project-slider .item._${item.customID}`)
                .classList.contains("active")
        ) {
            downX = e.offsetX;
        }
    }
}

function mouseUp(item: { customID: number }, e: any): void {
    if (window.innerWidth < 1024) {
        return;
    }
    if (
        document.querySelector(`.project-slider .item._${item.customID}`) !==
        null
    ) {
        if (
            document
                .querySelector(`.project-slider .item._${item.customID}`)
                .classList.contains("active")
        ) {
            upX = e.offsetX;
            if (downX > upX) {
                nextSlide();
            } else if (upX > downX) {
                prevSlide();
            }
        }
    }
}

function mobileLink(item: { customID: number }): void {
    if (window.innerWidth > 1024) {
        return;
    }
    if (
        document
            .querySelector(`.project-slider .item._${item.customID}`)
            .classList.contains("active")
    ) {
        window.location = get(item, "link.url");
    }
}

const imageLoaderEvent = () => {
    imagesLoaded('.project-slider', () => {
        imagesIsLoaded.value = true
    })
}
let imagesIsLoaded = ref(false)

nextTick(() => {
});
onMounted(async () => {
    // renderSwiper.value = false;
    // window.setTimeout(() => {
    //     renderSwiper.value = true;
    //     window.setTimeout(() => {
    //         moveBackgroundSwiper(true);
    //     }, 300);
    // }, 1000);
    uploadImages();
    checkHideFun(getData.value);
    if (window.innerWidth < 1024) {
        moveSwiperScroll();
        slideTouchEventsMobile();
    }
    await nextTick();
    window.setTimeout(() => {
        renderSwiper.value = true;
    }, 1000);
    window.setTimeout(() => {
        swiper.value.update();
        moveBackgroundSwiper(true);
        swiper.value.update();
    }, 1300);
    imageLoaderEvent()
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imageContainer.value, (img, index) => {
      return (_openBlock(), _createElementBlock("img", {
        class: "allImages",
        key: index,
        src: img
      }, null, 8, _hoisted_2))
    }), 128)),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", {
        class: "bottom-layer",
        "data-component-name": "slider",
        "data-scale-type": "0.8",
        onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (_unref(store).getComponentCursor($event, 'slider'))),
        onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_unref(store).getComponentCursor($event, null)))
      }, null, 32),
      _createElementVNode("div", _hoisted_5, [
        (renderSwiper.value)
          ? (_openBlock(), _createBlock(_unref(Swiper), {
              key: 0,
              "slides-per-view": swiperOptions?.slidesPerView,
              "space-between": swiperOptions?.spaceBetween,
              loop: swiperOptions?.loop,
              "centered-slides": swiperOptions?.centeredSlides,
              speed: swiperOptions?.speed,
              onSwiper: onSwiper
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getData), (item, index) => {
                  return (_openBlock(), _createBlock(_unref(SwiperSlide), { key: index }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$get(item, "title")), 1)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 8, ["slides-per-view", "space-between", "loop", "centered-slides", "speed"]))
          : _createCommentVNode("", true)
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getData), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(
                        item.customID === _unref(customIndex)
                            ? `item _${item.customID} active`
                            : `item _${item.customID}`
                    ),
              id: `main${item.customID}`,
              key: index,
              onClick: ($event: any) => (switchSlider(item)),
              onMousedown: ($event: any) => (mouseDown(item, $event)),
              onMouseup: ($event: any) => (mouseUp(item, $event)),
              "data-component-name": "slider",
              "data-scale-type": "0.8",
              onMouseenter: _cache[3] || (_cache[3] = ($event: any) => (_unref(store).getComponentCursor($event, 'slider'))),
              onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (_unref(store).getComponentCursor($event, null)))
            }, [
              _hoisted_11,
              _createElementVNode("div", {
                class: "img-cont",
                onClick: ($event: any) => (mobileLink(item))
              }, [
                _createElementVNode("canvas", {
                  class: _normalizeClass(["canvas", {
                                'is-clicking-slider': _unref(store).isClicking,
                            }])
                }, null, 2)
              ], 8, _hoisted_12),
              _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$get(item, "teaser")), 1),
              _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$get(item, "title")), 1),
              _hoisted_15,
              _createVNode(_component_router_link, {
                class: "link disable-drag wc-lg",
                to: _ctx.$get(item, 'link.url'),
                onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (_unref(store).getComponentCursor($event, null))),
                "data-scale-type": "0.167"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$fn.tr("explore")), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ], 42, _hoisted_10))
          }), 128))
        ]),
        _hoisted_17
      ], 512), [
        [_vShow, _unref(imagesIsLoaded)]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_18, _hoisted_20, 512), [
        [_vShow, !_unref(imagesIsLoaded)]
      ])
    ])
  ]))
}
}

})